import { userRole, userRoleFormate } from "@/constant/userRole";
import { useQueryParams } from "@/hooks/useQueryParams";
import { useGetAllSupportQuery } from "@/redux/api/supportApi";
import { useGetAllSupportResponseQuery } from "@/redux/api/supportResponseApi";
import { ReloadOutlined } from "@ant-design/icons";
import { Avatar, Button, Spin } from "antd";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const TicketList = ({ refetch }) => {
  const { queryParams, setQueryParams } = useQueryParams({ type: "" });
  const user = useSelector((state) => state.user?.userDetails) || {};

  // hooks
  const {
    isFetching,
    data: supports,
    refetch: supportRefetch,
  } = useGetAllSupportQuery({ ...queryParams, user: user?.role !== userRole.superAdmin ? user?._id : undefined, populate: "user" });

  const { refetch: responseRefetch } = useGetAllSupportResponseQuery({
    support: queryParams?.inbox,
    populate: "sender",
    sortOrder: "asc",
  });

  // const
  const tickets = supports?.data;

  const loading = isFetching;

  return (
    <Spin spinning={loading}>
      <div className="d-flex flex-column border-0 border-end border-secondary-subtle ticketList">
        <div className="m-2 d-flex justify-content-between align-items-center">
          <div className="fw-bold">Ticket List</div>

          <Button
            icon={<ReloadOutlined />}
            onClick={() => {
              supportRefetch();
              refetch();
              responseRefetch();
            }}
            type="text"
            shape="circle"
          />
        </div>
        <div className="overflow-y-scroll no-scrollbar ticketBody">
          {/* Placeholder for ticket items */}
          {Array.isArray(tickets) &&
            tickets.map((ticket, i) => (
              <div
                key={ticket?._id}
                onClick={() => setQueryParams({ inbox: ticket._id })}
                className={`p-2 d-flex align-items-center transition-all cursor-pointer ${ticket?._id === queryParams?.inbox ? "bg-body-secondary" : ""} ${i !== tickets.length - 1 ? "border-bottom border-secondary-subtle" : ""} `}
                style={{ gap: "0.625rem", transitionDuration: "300ms" }}
              >
                {user?.role === userRole.superAdmin ? (
                  <div className="d-flex gap-2 w-100">
                    <div>
                      <Avatar size="large" src={ticket?.user?.avatar} />
                    </div>
                    <p className="text-secondary">
                      <h3 className="fs-6 fw-bold mb-0"> {ticket?.user?.name} </h3>
                      <div> {userRoleFormate[ticket?.user?.role]} </div>
                    </p>
                    <div className="ms-auto">
                      <div className="fs-6 mb-0"> {dayjs(ticket?.createdAt).format("DD/MM/YYYY")} </div>
                      <div className="fs-6 mb-0"> {dayjs(ticket?.createdAt).format("HH:mm A")} </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {/* <div>
                      <Avatar size="large" src={ticket?.user?.avatar?.url} />
                    </div> */}
                    <div className="text-secondary w-100">
                      <div className="d-flex w-100 gap-2 align-items-center">
                        <div>
                          <h3 className="fs-6 fw-bold mb-0"> {ticket?.title} </h3>
                          {/* <div> {userRoleFormate[ticket?.user?.role]} </div> */}
                        </div>
                        <div className="ms-auto">
                          <div className="fs-6 mb-0"> {dayjs(ticket?.createdAt).format("DD/MM/YYYY")} </div>
                          <div className="fs-6 mb-0"> {dayjs(ticket?.createdAt).format("HH:mm A")} </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
        </div>
      </div>
    </Spin>
  );
};

export default TicketList;

TicketList.propTypes = {
  refetch: PropTypes.func,
};
